module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fb-circle-530.4f949f7a832154f7.png"+" 530w",
        images: [{path: "https://static.sniffspot.com/packs/img/fb-circle-530.4f949f7a832154f7.png",width: 530,height: 530}],
        src: "https://static.sniffspot.com/packs/img/fb-circle-530.4f949f7a832154f7.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/fb-circle-530.4f949f7a832154f7.png"},
        
        width: 530,
        height: 530
      }